import { z } from 'zod';
import { currencySchema } from './org';
import { priceMatrixSchema } from './price-matrix';

/** A row of `public.price_list_versions`. Immutable once published. */
export const priceListVersionSchema = z.object({
  id: z.uuid(),
  price_list_id: z.uuid(),
  version: z.number().int().positive(),
  matrix: priceMatrixSchema,
  created_by: z.uuid().nullable(),
  created_at: z.iso.datetime({ offset: true }),
});
export type PriceListVersion = z.infer<typeof priceListVersionSchema>;

/** A row of `public.price_lists` with its versions, newest first. Staff only. */
export const priceListSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  currency: currencySchema,
  is_default: z.boolean(),
  created_at: z.iso.datetime({ offset: true }),
  versions: priceListVersionSchema.array().min(1),
});
export type PriceList = z.infer<typeof priceListSchema>;

/** A row of `public.org_pricing` with the org's name, for "which orgs share this list". */
export const orgPricingSchema = z.object({
  organization_id: z.uuid(),
  organization_name: z.string(),
  price_list_id: z.uuid().nullable(),
  discount_percent: z.coerce.number().min(0).max(100).nullable(),
});
export type OrgPricing = z.infer<typeof orgPricingSchema>;

/** What `staff_resolve_pricing` returns: the list that applies to an org, its latest version and the discount. */
export const resolvedPricingSchema = z.object({
  price_list_id: z.uuid(),
  name: z.string(),
  is_default: z.boolean(),
  price_list_version_id: z.uuid(),
  version: z.number().int().positive(),
  currency: currencySchema,
  matrix: priceMatrixSchema,
  discount_percent: z.coerce.number().min(0).max(100).nullable(),
});
export type ResolvedPricing = z.infer<typeof resolvedPricingSchema>;
